import React from "react";

class ErrorHandler<PropsType> extends React.Component<PropsType, { hasError: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.warn(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return null;
    }

    return <></>;
  }
}

// HOC wrapping the passed component
export function withErrorBoundary<T>(WrappedComponent: any) {

  return (props: T) => {
    return <ErrorHandler>
      <WrappedComponent {...props} />
    </ErrorHandler>
  };

}
